module.exports = __webpack_public_path__ + "assets/img/media-music-layer-3-ce428b76.png";